import Footer from "@/app/Components/Footer/Footer";
import MenuHeader from "@/app/Components/Menu/MenuHeader";
import ToastMessage from "./ToastMessage";

export default function Layout({
  children,
  setMessageForSucessBanner,
  setSuccessBanner,
}) {
  return (
    <>
      <ToastMessage></ToastMessage>
      <MenuHeader
        setMessageForSucessBanner={setMessageForSucessBanner}
        setSuccessBanner={setSuccessBanner}
      />
      <main>{children}</main>
      <Footer />
    </>
  );
}
